import React from 'react';
import { RouteComponentProps } from 'react-router';
import { FortunaAdminListContainer } from '../../epic/admin-fortuna-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <FortunaAdminListContainer />;
};
